import { formatDate } from "@/core/helpers/DatetimeConverter";
import { MatchStates } from "@/core/helpers/MatchStates";

const SideBar = [

	{
		name: 'Game',
		label: 'Game',
		required: true,
		type: 'text',
		hideLabel: true,
		format: (item) => {
			return '<h1>'+item.homeTeamName + " - " + item.awayTeamName+'</h1><br>'
		}
	},
	{
		name: 'Score',
		label: 'Score',
		required: true,
		type: 'text',
		hideLabel: true,
		format: (item) => {
			
			return item.homeTeamGoals + " - " + item.awayTeamGoals
		}
	},
	{
		name: 'leagueName',
		label: 'League Name',
		required: true,
		type: 'text'
	},
	{
		name: 'gameStateID',
		label: 'State',
		required: true,
		type: 'text',
		format: (item) => {
			return MatchStates[item.gameStateID];
		}
	},
	{
		name: 'gameDate',
		dbName: 'gameDate',
		label: 'Game date',
		sortable: true,
		type: 'date',
		format: (item) => {
			return formatDate(item.gameDate);
		}

	}
	

];

export { SideBar };
